<template>
<svg xmlns="http://www.w3.org/2000/svg" 
     fill="none" viewBox="0 0 24 24" 
     stroke-width="1.5" stroke="currentColor" 
     >
  <rect x="4" y="3" width="16" height="4" rx="1" ry="1" />
  <rect x="4" y="9" width="16" height="4" rx="1" ry="1" />
  <rect x="4" y="15" width="16" height="4" rx="1" ry="1" />
  <circle cx="7" cy="5" r="0.5" fill="currentColor" />
  <circle cx="7" cy="11" r="0.5" fill="currentColor" />
  <circle cx="7" cy="17" r="0.5" fill="currentColor" />
</svg>
</template>

<script>


export default {
  setup() {

    return {

    }
  }
}
</script>

<style scoped>
</style>